// Red PI (Roary 04/11/2026, mục 9): sổ PI tách riêng. Tiếng Trung giản thể (luật vàng 8).
export const redPiEn = {
  label: "PI ledger",
  normal: "Normal PI",
  red: "Red PI",
  hint: "Switch between normal proforma invoices and Red PIs. Every sales screen and report follows the ledger you choose.",
  lockedEditing: "Save or cancel the form before switching ledger.",
  banner: "You are viewing the Red PI ledger",
  bannerHint: "Every sales screen and report shows only Red PIs and the documents raised from them. Switch back to Normal PI at the top.",
  backToNormal: "Back to Normal PI",
  tick: "Red PI",
  tickHint: "Numbered R001, R002…, kept apart from normal PIs. Cannot be changed later.",
  tickLocked: "New PIs in the Red PI ledger are always Red PIs.",
  badge: "Red",
  pageTitle: "Red PI",
  pageIntro: "Proforma invoices kept apart from normal PIs, numbered R001, R002… Their sales orders, packing lists, delivery notes, invoices, payments and reports are shown in the Red PI ledger only.",
  forbidden: "You may not create a Red PI.",
};

export const redPiVi = {
  label: "Sổ PI",
  normal: "PI thường",
  red: "Red PI",
  hint: "Chuyển giữa PI thường và Red PI. Mọi màn bán hàng và báo cáo theo sổ đang chọn.",
  lockedEditing: "Lưu hoặc huỷ biểu mẫu trước khi đổi sổ.",
  banner: "Đang xem sổ Red PI",
  bannerHint: "Mọi màn bán hàng và báo cáo chỉ hiện Red PI và chứng từ phát sinh từ chúng. Bấm PI thường ở thanh trên để quay lại.",
  backToNormal: "Về PI thường",
  tick: "Red PI",
  tickHint: "Số R001, R002…, tách riêng khỏi PI thường. Không đổi được về sau.",
  tickLocked: "PI lập trong sổ Red PI luôn là Red PI.",
  badge: "Red",
  pageTitle: "Red PI",
  pageIntro: "PI tách riêng khỏi PI thường, số R001, R002… Đơn bán, phiếu đóng gói, phiếu giao, hoá đơn, khoản thu và báo cáo của chúng chỉ hiện trong sổ Red PI.",
  forbidden: "Bạn không có quyền lập Red PI.",
};

export const redPiZh = {
  label: "PI 账簿",
  normal: "普通 PI",
  red: "Red PI",
  hint: "在普通形式发票与 Red PI 之间切换。所有销售页面和报表都按所选账簿显示。",
  lockedEditing: "请先保存或取消表单，再切换账簿。",
  banner: "正在查看 Red PI 账簿",
  bannerHint: "所有销售页面和报表只显示 Red PI 及由其产生的单据。点击顶部的普通 PI 返回。",
  backToNormal: "返回普通 PI",
  tick: "Red PI",
  tickHint: "编号 R001、R002…，与普通 PI 分开。之后不能更改。",
  tickLocked: "在 Red PI 账簿中新建的 PI 一律为 Red PI。",
  badge: "Red",
  pageTitle: "Red PI",
  pageIntro: "与普通 PI 分开的形式发票，编号 R001、R002… 其销售订单、装箱单、送货单、发票、收款和报表只在 Red PI 账簿中显示。",
  forbidden: "您没有权限新建 Red PI。",
};
